import { render, staticRenderFns } from "./AllOutreachRequestsTab.vue?vue&type=template&id=b64fa282&"
import script from "./AllOutreachRequestsTab.vue?vue&type=script&lang=js&"
export * from "./AllOutreachRequestsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports